/**
 * Prazo de contrato e cronograma.
 *
 * A comparação entre o calendário e o dinheiro — quanto do prazo passou contra
 * quanto do contrato foi pago — é a leitura de atraso que o sistema reconhece.
 * Mora aqui, uma vez, porque a listagem, o analítico e o painel a fazem, e três
 * cópias da mesma conta é como se chega a três números diferentes.
 */

import { daysBetween, ratio, type DateInput } from './format.js';

/** Fração do prazo de contrato já decorrida, em [0, 1]. Sem as duas datas, zero. */
export function contractTimeProgress(
  start: DateInput | null | undefined,
  end: DateInput | null | undefined,
  today: DateInput,
): number {
  if (!start || !end) return 0;

  const total = daysBetween(start, end);
  if (total <= 0) return 1;

  return ratio(daysBetween(start, today), total);
}

/**
 * A partir de quanto a obra é dada como atrasada.
 *
 * `gap` é a execução financeira menos o prazo decorrido, os dois em fração do
 * total. Quinze pontos percentuais de folga porque medição não acompanha o
 * calendário dia a dia: ela é lançada em blocos, e uma obra que mediu ontem
 * parece adiantada, a mesma obra na véspera da medição parece atrasada.
 * Abaixo disso é ruído de medição, não atraso.
 */
export const SCHEDULE_GAP_THRESHOLD = 0.15;

/** `gap` de `executionProgress - timeProgress`: negativo é obra atrás do calendário. */
export function behindSchedule(gap: number): boolean {
  return gap < -SCHEDULE_GAP_THRESHOLD;
}
